export default {
  ru: {
    access_guide: 'Ваш дом под вашим контролем',
  },

  en: {
    access_guide: 'Your home is under your control',
  },
}